export default {
    recruitmentDepthChart: null,
    error: '',
};
